export const getInjuryReportStatusTextId = (statusId: number) => `STATUS_INJURY_REPORT/${statusId}`

export const extractCommentFromInjuryReport = (comment: string | null) => {
  if (!comment) return null
  const trimmedComment = comment.trim()
  if (!trimmedComment) return null

  // Check if comment has timestamp format [YYYY-MM-DD HH:MM - Username]:
  const timestampMatch = trimmedComment.match(
    /^\[(\d{4}-\d{2}-\d{2} \d{2}:\d{2})\s*-\s*([^\]]+)\]:\s*(.+)$/
  )
  if (!timestampMatch)
    return {
      timestamp: null,
      username: null,
      commentText: trimmedComment,
    }

  const [, timestamp, username, commentText] = timestampMatch

  return {
    timestamp,
    username,
    commentText,
  }
}
